<template>
  <div class="information">
    <el-dialog title="天气专报" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body="false" ref="infoRef" :before-close="() => params.flag && $parent.toggleProductView(params.productInfo.code)
        ">
      <div slot="title" class="select-header">
        <span>天气专报</span>
      </div>
      <div class="main">
        <div class="auto-station-wrap">
          <el-table :data="tableData" height="100%" style="width: 100%" v-loading="loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column prop="filename" label="标题">
              <template slot-scope="scope">
                <el-link type="primary" :href="`https://www.fspms.cn/data/${scope.row.path}`" target="_blank">
                  <p class="article_title">
                    {{ scope.row.filename }}
                  </p>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="crttime" label="创建时间">
              <template slot-scope="scope">
                <p>{{ formatDate(scope.row.crttime) }}</p>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page" :page-size="queryParams.pageSize" layout="total, prev, pager, next"
            :total="total" style="display: none">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiData } from "../api/index";
import { Link } from "element-ui";
import { formatDate } from "@/utils/common";
const PREFIX_URL = process.env.VUE_APP_PREFIX_URL;
console.log("PREFIX_URL", PREFIX_URL);
export default {
  props: ["params"],
  components: {
    "el-link": Link,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      company: "",
      total: 0,
      PREFIX_URL,
      queryParams: {
        page: 1,
        pageSize: 5,
      },
      query: {},
    };
  },
  watch: {
    "params.flag": {
      handler(flag) {
        flag && this.setZindex();
      },
      immediate: true,
    },
  },
  created() {
    const { company } = this.$route.params;
    this.company = company;
    const { unit } = JSON.parse(localStorage.getItem(company));
    console.log("unit", unit);
    this.queryParams.unitid = unit.id;
    this.query.unitid = unit.id;
    this.getArticleList();
  },
  methods: {
    formatDate,
    getArticleList() {
      this.loading = true;
      apiData.queryHyReport(this.query.unitid).then((response) => {
        this.tableData = response.data;
        // this.total = response.data.rows;
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize;
      this.getArticleList();
    },
    handleCurrentChange(currentPage) {
      this.queryParams.page = currentPage;
      this.getArticleList();
    },
    // 设置弹出框的zIndex
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.infoRef;
        let zIndex = JSON.parse(localStorage.getItem("dialogZIndex"));
        zIndex = zIndex * 1 + 1;
        el.$el.style.zIndex = zIndex;
        localStorage.setItem("dialogZIndex", JSON.stringify(zIndex));
      });
    },
  },
};
</script>
<style lang="less" scoped>
.information {
  display: flex;
  flex-direction: column;
  pointer-events: none;

  .select-header {
    display: flex;
    align-items: center;
    font-size: 0.94vw;
    font-weight: 600;
    color: #fff;
    line-height: 1.3vw;

    .image {
      display: flex;
      align-items: center;
      position: relative;
      margin-left: 0.31vw;

      img {
        width: 0.94vw;
      }

      &:hover {
        cursor: pointer;

        .image-tip {
          display: block;
        }
      }

      .image-tip {
        position: absolute;
        z-index: 9;
        top: 130%;
        display: none;
        left: -3.13vw;
        height: 2.6vw;
        width: 20.16vw;
        font-size: 0.73vw;
        color: #fff;
        line-height: 2.6vw;
        text-align: center;
        background: #212c45;
        border-radius: 0.63vw;
        border: 1px solid #52607f;
        box-shadow: 0vw 0.1vw 0.36vw 0vw rgba(0, 0, 0, 0.15);

        .sanjiao {
          position: absolute;
          z-index: 9;
          top: -0.83vw;
          left: 3.13vw;
          display: inline-block;
          display: none;
          width: 0;
          height: 0;
          border: 0.42vw solid transparent;
          border-bottom-color: #fff;
          box-shadow: 0vw 0vw 0vw 0vw rgba(0, 0, 0, 0.15);
        }
      }
    }
  }

  .search-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .datetime {
      display: flex;
      align-items: center;
    }

    .element {
      display: flex;
      align-items: center;

      /deep/ .el-select {
        .el-input {
          .el-input__inner {
            border-radius: 0.25rem;
            border: 1px solid #52607f;
            width: 9rem;
            height: 2.5rem;
            line-height: 2.5rem;
            font-size: 0.88rem;
            color: #fff;
          }

          .el-select__caret {
            height: 2.5rem;
            line-height: 2.5rem;
          }
        }
      }
    }

    .name {
      input {
        width: 15rem;
        height: 2.38rem;
        padding-left: 0.26vw;
        border-radius: 0.25rem;
        outline: none;
        font-size: 0.88rem;
        background: #5592cb;
        border: 1px solid #5592cb;
        color: #fff;
      }

      input::placeholder {
        color: #fff;
        padding: 0.26vw;
      }
    }

    .search {
      padding: 0.52vw 1.09vw 0.52vw;
      border: 0;
      cursor: pointer;
      font-size: 0.73vw;
      color: #ffffff;
      background: linear-gradient(204deg,
          #5e9cd9 0%,
          rgba(66, 139, 211, 0.46) 100%);
      border-radius: 0.31vw;
      border: 0.05vw solid rgba(255, 255, 255, 0.5);
      margin-left: 15.05rem;
    }

    label {
      font-size: 1rem;
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-weight: 600;
      color: #fff;
      width: 3.2rem;
      display: inline-block;
      flex-shrink: 0;
    }

    .name {
      label {
        width: 5.5rem;
      }
    }

    /deep/ .DatePicker {
      font-size: 0.88rem;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      font-weight: 400;
      color: #fff;

      .picker-box-inner {
        border-radius: 0.25rem;
        background: #5592cb;
        border: 1px solid #5592cb;

        .date-picker {
          background: #5592cb;
          width: 7.5rem;
        }
      }

      .el-input__inner {
        color: #fff;
        font-size: 0.88rem;
        height: 2.5rem;
        line-height: 2.5rem;
      }

      .icon-caret-top {
        top: 0.8rem;
        border-bottom: 0.5em solid #cccccc;
      }

      .icon-caret-bottom {
        top: 1.4rem;
        border-top: 0.5em solid #cccccc;
      }

      .el-input__prefix {
        color: #cccccc;
      }

      .el-input__icon {
        height: 2.5rem;
        line-height: 2.5rem;
        font-size: 1rem;
      }
    }
  }

  .main {
    flex: 1;
    position: relative;

    .auto-station-wrap {
      position: absolute;
      left: 0;
      top: 1.25rem;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;

      /deep/ .el-table__empty-block {
        width: 100% !important;
      }

      .el-table {
        background: transparent;
        text-align: center;

        /deep/ tr {
          background: transparent;

          th {
            text-align: center;
            border: 0;
            font-size: 0.88rem;
            font-weight: 600;
            color: #fff;
            background: #2c6aa3;
          }

          td {
            text-align: center;
            font-size: 0.88rem;
            font-weight: 400;
            color: #fff;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .print {
            width: 1.13rem;
            height: 1.13rem;
            background: url("../assets/images/打印.png") no-repeat;
            border: 0;
            cursor: pointer;
            background-size: 1.13rem 1.13rem;
          }

          .image {
            margin: 0.52vw;
            width: 1.09vw;
            cursor: pointer;
          }
        }

        /deep/ tr:hover td {
          background: #2c6aa3 !important;
        }

        .new {
          margin-left: 0.52vw;
          background-color: #f56c6c;
          border-radius: 0.32vw;
          color: #fff;
          display: inline-block;
          font-size: 0.43vw;
          height: 0.94vw;
          line-height: 0.94vw;
          padding: 0.1vw 0.31vw;
          text-align: center;
          white-space: nowrap;
        }

        /deep/ .el-table__body-wrapper {
          overflow-y: auto;
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background: #273458;
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
          border-radius: 5px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #1b2230;
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
          border-radius: 5px;
          background: #0c4170;
        }

        /deep/ .el-table__fixed-right-patch {
          background: #1b3b80;
          border: 0;
        }
      }

      .el-table::before {
        background: transparent;
      }
    }
  }

  /deep/ .el-dialog__wrapper {
    overflow: hidden;

    .el-dialog {
      pointer-events: auto;
    }
  }

  .el-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    /deep/ .el-pager li {
      background: transparent;
      color: #fff;
    }

    /deep/ .el-pager li.active {
      color: #6fbeff;
    }

    /deep/ .el-pagination__total {
      color: #fff;
    }

    /deep/ .btn-prev,
    .btn-next {
      background: transparent;
      color: #fff;
    }

    /deep/ .btn-next {
      background: transparent;
      color: #fff;
    }

    /deep/ .el-icon {
      color: #afa7a7;
    }
  }

  /deep/.el-dialog__wrapper {
    overflow: hidden;

    .el-dialog {
      width: 76rem;
      pointer-events: auto;
    }
  }

  .article_title {
    color: #fff;
    font-size: 0.88rem;
  }
}
</style>
